module.exports = __webpack_public_path__ + "img/avatar.ddcee11a.png";